<h3 i18n="Title for the story removal confirmation dialog@@REMOVE_STORY">Are you sure you want to remove this story?</h3>

<button class="submit" (click)="dialogRef.close(true)" i18n="Text for the button to confirm the story deletion in the story removal confirmation dialog@@DELETE_STORY">Delete the story</button>
<button class="text-btn" (click)="dialogRef.close()" i18n="Text for the button to cancel the action in progress@@CANCEL">Cancel</button>
